import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CREW_INFO, getItemFromSessionStorage } from 'src/app/utils/SessionStorageUtil';
import { CrewInfoStore } from 'src/app/core/services/crew-info/crew-info.store';
import { ExternalCrewInfo } from 'src/app/models/ExternalCrewInfo';

@Component({
  selector: 'app-external-validation',
  templateUrl: './external-validation.component.html',
  styleUrls: ['./external-validation.component.scss'],
  standalone: false
})
export class ExternalValidationComponent implements OnInit {

  crewInfo: ExternalCrewInfo | null = null;
  validationMode: 'first-access' | 'mfa' | null = null;

  constructor(private router: Router, private crewInfoStore: CrewInfoStore) {}

  ngOnInit(): void {
    this.crewInfo = getItemFromSessionStorage<ExternalCrewInfo>(CREW_INFO);

    // Security: Redirect to login if no crew info
    if (!this.crewInfo) {
      this.router.navigate(['/external-login']);
      return;
    }

    // Security: Redirect to home if validation already completed
    if (!this.crewInfo.requiresMfa && !this.crewInfo.firstAccess) {
      this.router.navigate(['/external-home']);
      return;
    }

    // Determine validation mode
    if (this.crewInfo.firstAccess) {
      this.validationMode = 'first-access';
    } else if (this.crewInfo.requiresMfa) {
      this.validationMode = 'mfa';
    }
  }

  onValidationComplete(result: { mfaVerified?: boolean }): void {
    // Handle MFA validation completion
    if (this.validationMode === 'mfa' && result?.mfaVerified) {
      // Update crewInfo to mark MFA as completed
      if (this.crewInfo) {
        this.crewInfo.requiresMfa = false;
        this.crewInfoStore.setCrewInfo(this.crewInfo);
      }
      // Redirect to home
      this.router.navigate(['/external-home']);
    }
    // Note: first-access mode redirects to login automatically in ChangePasswordComponent
  }
}
